export default __webpack_public_path__ + "static/media/uploadFile.45b75ccf.svg";